import { AutogenModelFactoringCompanyLookup, AutogenRowFactoringCompanyLookup } from "./autogen/AutogenModelFactoringCompanyLookup";

export class ModelFactoringCompanyLookup extends AutogenModelFactoringCompanyLookup<RowFactoringCompanyLookup> {
	constructor() {
		super(RowFactoringCompanyLookup);
	}
}

export class RowFactoringCompanyLookup extends AutogenRowFactoringCompanyLookup {
}